var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useExtendedLogger } from '../Logger';
import { DEFAULT_LOCALE, LOGGER_NAME } from './constants';
import { addDummyLocaleData } from './helpers';
var Context = React.createContext({
    currentLanguage: DEFAULT_LOCALE,
    changeLanguage: function () { return null; },
});
function Provider(_a) {
    var children = _a.children, _b = _a.locale, initialLocale = _b === void 0 ? DEFAULT_LOCALE : _b;
    var log = useExtendedLogger(LOGGER_NAME);
    var _c = __read(useState(initialLocale), 2), locale = _c[0], setLocale = _c[1];
    var changeLanguage = useCallback(function (locale) {
        addDummyLocaleData(locale);
        setLocale(locale);
    }, []);
    var context = useMemo(function () { return ({
        changeLanguage: changeLanguage,
        currentLanguage: locale,
    }); }, [changeLanguage, locale]);
    useEffect(function () { return addDummyLocaleData(locale); }, [locale]);
    log('adding locale provider with context %o', context);
    return _jsx(Context.Provider, __assign({ value: context }, { children: children }), void 0);
}
export { Context, Provider };
//# sourceMappingURL=LocaleProvider.js.map